module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serial-form"
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryout-groups'
      }
    }
  }, [_vm._v("Tryout Serial")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Serial Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nama tryout serial"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Deskripsi tryout serial"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((9), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n + 3
      }
    }, [_vm._v(_vm._s(n + 3))])
  }), 0)])]), _vm._v(" "), (_vm.id != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Serial")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-tryoutgroupchooser', {
    attrs: {
      "params": {
        grade: _vm.grade,
        attached: false
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.onGroupSelected($event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('div', {
      key: group.series_sequence,
      staticClass: "panel panel-inverse"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('div', {
      staticClass: "btn-group pull-right"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger btn-icon btn-circle",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.confirmUnAttachGroup(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]), _vm._v(" "), _c('h4', {
      staticClass: "panel-title"
    }, [_vm._v("group id: " + _vm._s(group.id))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body bg-silver-lighter m-b-5"
    }, [_c('h4', [_c('a', {
      staticClass: "btn btn-inverse btn-icon btn-circle text-white m-r-10"
    }, [_vm._v(_vm._s(group.series_sequence))]), _vm._v("\n                                            " + _vm._s(group.name) + "\n                                        ")])])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showUnAttachModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.processUnAttachGroup()
      },
      "cancel": function($event) {
        _vm.showUnAttachModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Tryout Group")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus Tryout Group "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.selectedGroup.name))]), _vm._v("\n        dari Serial "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Buat Tryout Serial")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-781bacd8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/serial/Form.vue
// module id = 1371
// module chunks = 0